export const roleEnum = {
  DELIVERY_NURSE: "1",
  ADMINISTRATOR: "2"
};

export const statusColorEnum = {
  2: "success",
  3: "danger",
  4: "warning"
};

export const statusEnum = {
  OPEN: 1,
  MEDIATED: 2,
  NOT_MEDIATED: 3,
  PARTIALLY_ASSIGNED: 4
};

export const assignmentModeEnum = {
  PARTIALLY: 1,
  FULLY: 2,
  REMOVE: 3
};
